import { Reveal, SectionHeading } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Chiami",
    text: "Descrivi il problema e indica la tua zona.",
  },
  {
    n: "02",
    title: "Verifichiamo",
    text: "Valutiamo il problema e la disponibilità del servizio.",
  },
  {
    n: "03",
    title: "Interveniamo",
    text: "Se possiamo gestire direttamente il lavoro, interveniamo noi. Se necessario, verifichiamo la disponibilità di un professionista partner.",
  },
];

export const HowItWorks = () => (
  <section
    id="come-funziona"
    data-testid="how-it-works-section"
    className="scroll-mt-24 py-20 sm:py-28"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        overline="Come funziona"
        title="Tre passaggi, zero complicazioni"
      />

      <div className="relative mt-14 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
        <div
          aria-hidden="true"
          className="absolute left-0 right-0 top-7 hidden border-t border-dashed border-white/10 md:block"
        />
        {STEPS.map((step, idx) => (
          <Reveal key={step.n} delay={idx * 0.12}>
            <div
              data-testid={`how-it-works-step-${idx + 1}`}
              className="relative"
            >
              <div className="relative z-10 inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-amber-400/30 bg-[#0A0D12] font-tech text-lg font-semibold text-amber-400">
                {step.n}
              </div>
              <h3 className="mt-5 font-display text-xl sm:text-2xl font-bold uppercase tracking-tight text-zinc-100">
                {step.title}
              </h3>
              <p className="mt-2.5 max-w-xs text-sm sm:text-base text-zinc-400 leading-relaxed">
                {step.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
